import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Experiences } from 'src/app/shared/models/experiences.model';
import * as moment from 'moment';
import { FilterItem } from 'src/app/shared/base-reporting/models/filter-item.interface';
import { FilterCallback } from 'src/app/shared/base-reporting/models/filter-callback.interface';
import { RowAction } from 'src/app/shared/base-reporting/models/row-actions.interface';
import { RowActionCallback } from 'src/app/shared/base-reporting/models/row-action-callback.interface';
import { Router } from '@angular/router';
import { ExperiencesService } from '../experiences.service';

@Component({
  selector: 'app-experiences-log',
  templateUrl: './experiences-log.component.html',
  styleUrls: ['./experiences-log.component.css']
})
export class ExperiencesLogComponent implements OnInit {
  viewFlag = false;
  viewAdminApprovalFlag = false;
  experienceTypes = [];
  @ViewChild('viewExp', { static: true }) viewExp: ElementRef;

  experience = new Experiences();
  get data(): Array<TableViewItem> {
    return this.Data.filter(row => {
      if (this.currentFilterObject.experienceType) {
        return this.currentFilterObject.experienceType.includes(
          row.experienceType
        );
      }
      return true;
    })
      .filter(row => {
        if (
          this.currentFilterObject.startDate &&
          this.currentFilterObject.startDate.startDate &&
          this.currentFilterObject.startDate.endDate
        ) {
          return moment(row.startDate).isBetween(
            // @ts-ignore
            this.currentFilterObject.startDate.startDate._i,
            // @ts-ignore
            this.currentFilterObject.startDate.endDate._i
          );
        } else {
          return true;
        }
      })
      .filter(row => {
        if (this.currentFilterObject.price) {
          if (row.price.includes(':')) {
            let from = +row.price.split(':')[0];
            let to = +row.price.split(':')[1];

            return (+this.currentFilterObject.price >= from && +this.currentFilterObject.price <= to)
          }
          else {
            return +this.currentFilterObject.price == +row.price;
          }
        }
        return true;
      })
    // .filter(row => {
    //   if (this.currentFilterObject.rating) {
    //     return row.rating.includes(this.currentFilterObject.rating);
    //   }
    //   return true;
    // });
  }
  set data(v: Array<TableViewItem>) {
    this.Data = v;
  }
  private Data = [] as Array<TableViewItem>;

  tableColumns = [
    'experienceName',
    'experienceType',
    'startDate',
    'price',
    // 'rating'
  ];

  reportFilter: Array<FilterItem> = [
    {
      fieldName: 'startDate',
      fieldDisplayName: 'Start Date ',
      fieldType: 'daterange'
    },
    {
      fieldName: 'experienceType',
      fieldDisplayName: 'Experience Type ',
      fieldType: 'select',
      multiple: true,
      hasSelectAll: false,
      defaultValue: null,
      options: [
      ]
    },
    {
      fieldName: 'price',
      fieldDisplayName: 'Price ',
      fieldType: 'text'
    },
    // {
    //   fieldName: 'rating',
    //   fieldDisplayName: 'Rating ',
    //   fieldType: 'select',
    //   multiple: false,
    //   hasSelectAll: false,
    //   defaultValue: null,
    //   options: []
    // }
  ];

  constructor(private expeirenceApi: ExperiencesService, private router: Router) { }

  currentFilterObject = {} as FilterModel;
  rowActions: Array<RowAction> = [
    {
      type: 'icon',
      slug: 'viewExperience',
      class: 'btn',
      iconClasses: 'fa fa-eye',
      onClick: this.updateViewFlag()
    },
    {
      type: 'icon',
      slug: 'editExperience',
      class: 'btn',
      iconClasses: 'fa fa-edit'
    },
    {
      type: 'icon',
      slug: 'addImageAlt',
      class: 'btn',
      iconClasses: 'fa fa-plus'
    }
  ];

  ngOnInit() {
    // this.sharedService.getLanguages().then(response => {
    //   this.reportFilter[1].options = response.data.languages.map(l => ({value: l.id, display: l.name}))
    // })

    this.fetchAllExperiences();
  }

  onFilter(event: FilterCallback) {
    this.currentFilterObject = event.filter;
  }

  private fetchAllExperiences() {
    this.expeirenceApi.getAllExperience().subscribe(response => {
      // console.log(response)
      this.data = response.data.experiences.map(r => {
        this.experienceTypes = r.ExperienceTypes;
        this.reportFilter[1].options = r.ExperienceTypes.map(l => ({
          value: l.id,
          display: l.name
        }));
        this.reportFilter[1].options.push(
          { value: 'WEEKLY', display: 'WEEKLY' },
          { value: 'SEASONAL', display: 'SEASONAL' },
          { value: 'WEEKLY SEASONAL', display: 'WEEKLY/SEASONAL' },
          { value: 'ONLINE Experience', display: 'ONLINE Experience' },
          { value: null, display: 'All' }
        );
        this.experience = r;
        // console.log(r)
        if (r.city == null) {
          r.city = '-';
          r.country = '-';
        }
        // let rate = '';
        // if (r.rating == null) {
        //   rate = '-';
        // } else {
        //   rate = r.rating;
        // }
        let expType = '';
        let expID = '';
        if (r.ExperienceTypes == null) {
          expType = '-';
          expID = '-';
        } else {
          if (r.OnlineExperienceDetails) {
            expType = 'ONLINE Experience';
            expID = 'ONLINE_EXPERIENCE';
          } else {
            if (r.ExperienceTypes.length === 1) {
              expType = r.ExperienceTypes[0].name;
              expID = r.ExperienceTypes[0].id;
            } else {
              expType =
                ( r.ExperienceTypes[0] ? r.ExperienceTypes[0].name + ' ' + r.ExperienceTypes[1].name : '');
              expID = (r.ExperienceTypes[0] ? r.ExperienceTypes[0].id + '' + r.ExperienceTypes[1].id : '');
            }
          }
        }
        let localname = '';
        if (r.Local == null) {
          localname = '-';
        } else {
          localname = r.Local.firstName + ' ' + r.Local.lastName;
        }

        let price: string = '';
        let priceMax = '';
        let priceMin = '';
        if (r.Price.length === 1) price = r.Price[0].amount;
        else {
          priceMax = Math.max.apply(Math, r.Price.map(a => a.amount));
          priceMin = Math.min.apply(Math, r.Price.map(a => a.amount));
          price = priceMin + ' : ' + priceMax
        }


        return {
          id: r.id,
          experienceName: r.name,
          expTypeID: expID,
          experienceType: expType,
          localName: localname,
          startDate: moment(r.startDate).format('YYYY-MM-DD HH:mm'), //r.startDate,
          price: String(price),
          // rating: rate,
          isOnline: !!r.OnlineExperienceDetails
        } as TableViewItem;
      });
    });
  }
  updateViewFlag () {
    this.viewFlag = true;
  }
  rowActionCB(event: RowActionCallback) {
    switch (event.action) {
      case 'viewExperience':
        this.viewExp.nativeElement.click();
        this.viewFlag = true;
        this.experience = event.on;
        break;
      case 'editExperience':
        if (event.on.isOnline) {
          this.editOnlineExperience(event.on.id);
        } else {
          this.editExperience(event.on.id);
        }
        break;
      case 'addImageAlt':
        this.addImageAlt(event.on.id);
        break;
      default:
        console.error('this is a mistake!');
    }
  }
  editExperience(id) {
    this.router.navigate(['/experiences/edit/' + id]);
  }
  addImageAlt(id) {
    this.router.navigate(['/experiences/image-alt/' + id]);
  }
  editOnlineExperience(id) {
    this.router.navigate(['/experiences/online/edit/' + id]);
  }
}

interface TableViewItem {
  id: number;
  experienceName?: string;
  experienceType?: string;
  expTypeId?: any;
  startDate?: string;
  price?: string;
  // rating?: string;
  isOnline?: boolean;
}
interface DateRangeModel {
  startDate?: moment.Moment;
  endDate?: moment.Moment;
}
interface FilterModel {
  experienceType: string;
  startDate: DateRangeModel;
  price: string;
  // rating: string;
}
